import { Controller } from "@hotwired/stimulus"
import toastr from "toastr";

// flash はプレーンテキスト専用。message が HTML として解釈されないようにする
toastr.options.escapeHtml = true;

// Connects to data-controller="toastr"
export default class extends Controller {
  static values = {
    flashKey: String,
    message: String
  }

  connect() {
    this.execute();
  }

  execute() {
    switch (this.flashKeyValue) {
      case 'notice':
      case 'info':
        toastr.info(this.messageValue);
        break;
      case 'alert':
      case 'error':
        toastr.error(this.messageValue);
        break;
      default:
        toastr.success(this.messageValue);
    }
  }
}
